export default class Tiles {

    static initializeEvents() {
        Array
            .from(document.querySelectorAll('.tiles'))
            .forEach(tiles => {
                if (tiles.childElementCount % 3 && !(tiles.childElementCount % 2)) {
                    tiles.querySelectorAll('div').forEach(
                        function (node) {
                            node.classList.replace('grid-col-md-4', 'grid-col-md-6');
                        }
                    );
                }
            });
    }
}
